/**
 * Canais do VisionFT — gerado a partir de visionft_enums.rs.
 *
 * Sample_Time/Sample_Index são colunas fixas dos arquivos Parquet (sem measureId).
 * Os demais canais correspondem ao measureId (u16) do .ftlog — ver visionft_enums.rs
 * para o mapeamento numérico (a ordem aqui segue o id crescente).
 *
 * Tipado como readonly string[] (em vez de keyof de uma interface gigante) para
 * evitar OOM no compilador TypeScript durante o build.
 */
export const VISION_FT_CHANNEL_NAMES: readonly string[] = [
  'Sample_Time',
  'Sample_Index',
  'RPM',
  'RPM_Control',
  'RPM_LoRes',
  'RPM_HiRes',
  'RPM_Cam',
  'MAP',
  'PedalPos',
  'TPS',
  'Battery_Voltage',
  'Injection_Time_A',
  'Injection_Duty_A',
  'Injection_Time_B',
  'Injection_Duty_B',
  'Injection_Time_C',
  'Injection_Duty_C',
  'Injection_Phase_A',
  'Ignition_Timing',
  'Air_Temperature',
  'Engine_Temperature',
  'O2',
  'WheelieCut',
  'Speed',
  'Ignition_Dwell',
  'BoostRPM_1',
  'BoostRPM_2',
  'EGate_MAP_Target',
  'InjO2CL_Target',
  'InjO2CL_Value',
  'InjO2CL_Correction',
  'ProNitro_CylTrim_1',
  'Clutch_Slip',
  'TimeBased_IgnRetard',
  'TimeBased_InjEnrich',
  'EGT_Avr',
  'EGT_Cil01',
  'EGT_Cil02',
  'EGT_Cil03',
  'EGT_Cil04',
  'EGT_Cil05',
  'EGT_Cil06',
  'EGT_Cil07',
  'EGT_Cil08',
  'EGT_Cil09',
  'EGT_Cil10',
  'EGT_Cil11',
  'EGT_Cil12',
  'EGT_Cil13',
  'EGT_Cil14',
  'EGT_Cil15',
  'EGT_Cil16',
  'EGT_Right',
  'EGT_Left',
  'FuelPump_Btn',
  'VCUData_Vago054',
  'VCUData_Vago055',
  'FlexFuel_Ethanol',
  'Fuel_Temperature',
  'Fuel_Pressure',
  'Fuel_DiffPressure',
  'Flow_BankA',
  'Oil_Pressure',
  'Idle_Position',
  'Idle_Valve_PWM',
  'AC_Inj_Comp',
  'Fan1_Inj_Comp',
  'ALS_Ign_Comp',
  'ALS_Inj_Comp',
  'LaunchLap_Time',
  'Gear_Actual',
  'HardCut_CutLevel',
  'Engine_Sync_Ok',
  'Engine_SyncSensor_Ok',
  'CutOff_CutLevel',
  'Boost1_BoostP_Btn',
  'Engine_Crank',
  'Idle_Signal',
  'Inj_FirstPulse',
  'ALS_CutLevel',
  'Backpressure_1',
  'Backpressure_2',
  'Inj_FastDecay',
  'HiResPwrRed_Level',
  'ProgNitrous1_Out',
  'ProgNitrous2_Out',
  'PWMOutputDuty',
  'MAP_External',
  'ActiveMapIdx',
  'EGate_Pos1',
  'EGate_Pos2',
  'EGate_Temp1',
  'EGate_Temp2',
  'PowerGND',
  'VCUData_Vago093',
  'FuelPump_Signal',
  'AC_Button',
  'Speed_Traction',
  'Speed_Drag',
  'Speed_FL',
  'Speed_FR',
  'Speed_RL',
  'Speed_RR',
  'Acc_Speed',
  'ATC_Slip',
  'ATC_SlipRate',
  'ATC_SpeedDiff',
  'SyncSensor_Pos',
  'TPS_Delta',
  'Acc_Front',
  'Acc_Lateral',
  'Pitch_Frontal',
  'PitchRate_Frontal',
  'Heading',
  'Pitch_Lateral',
  'Distance',
  'PitchRate_Lateral',
  'Acc_Front_RAW',
  'Acc_Lateral_RAW',
  'PCB_Temp1',
  'PCB_Temp2',
  'ProNitro_CylTrim_2',
  'WheelSensor_Tooths',
  'TimeBased_RPM_IgnComp',
  'TimeBased_SpdDrvShft_IgnComp',
  'TimeBased_ETCLim',
  'WheelieRetard',
  'ATC_SlipTarget',
  'BoostCtrl_1_3wPWM_DC',
  'BoostCtrl_1_IncPulseUS',
  'BoostCtrl_1_DecPulseUS',
  'BoostCtrl_2_3wPWM_DC',
  'BoostCtrl_2_IncPulseUS',
  'BoostCtrl_2_DecPulseUS',
  'ProNitro_IgnComp',
  'ProNitro_InjComp_A',
  'ProNitro_InjComp_B',
  'ProNitro_InjComp_C',
  'ProNitro_CylTrim_3',
  'ProNitro_CylTrim_4',
  'ProNitro_CylTrim_5',
  'ProNitro_CylTrim_6',
  'Inj_Fast',
  'Inj_Decay',
  'Inj_CutOff',
  'Idle_RPMTarget',
  'PostStart',
  'BoostCtrl_1_Target',
  'BoostCtrl_2_Target',
  'ProNitro_CylTrim_7',
  'ProNitro_CylTrim_8',
  'ProNitro_CylTrim_9',
  'Boost2_BoostP_Btn',
  'BrakePress',
  'SteeringAngle',
  'Start_Button',
  'EGate_P',
  'EGate_I',
  'EGate_D',
  'EGate_PosTarget_1',
  'EGate_PosTarget_2',
  'GPS_Latitude',
  'GPS_Longitude',
  'Flow_Total',
  'Datalogger_Btn',
  'ProgNitro1_Btn',
  'ProgNitro2_Btn',
  'AuxOutPwm_Btn',
  'Shifter5VSensor',
  'PitLimit_Btn',
  'ActiveTraction_Btn',
  'GenOut_1_Btn',
  'GenOut_2_Btn',
  'GenOut_3_Btn',
  'GenOut_4_Btn',
  'GenOut_5_Btn',
  'GenOut_6_Btn',
  'GenOut_7_Btn',
  'GenOut_8_Btn',
  'GenOut_9_Btn',
  'GenOut_10_Btn',
  'GenOut_11_Btn',
  'GenOut_12_Btn',
  'GenOut_13_Btn',
  'GenOut_14_Btn',
  'GenOut_15_Btn',
  'GenOut_16_Btn',
  'GenOut_17_Btn',
  'GenOut_18_Btn',
  'GenOut_19_Btn',
  'GenOut_20_Btn',
  'Blip_Btn',
  'ProNitro_Btn',
  'Clutch_Btn',
  '2Step_Btn',
  '3Step_Btn',
  'Vehicle_State',
  'VE',
  'VE_AFR',
  'FuelEconomy',
  'FuelLevel',
  'Odometer',
  'AC_SetPoint',
  'DriveShaft_RPM',
  'AirComp_Pressure',
  'BrakePress_F',
  'DayNight_Btn',
  'Transmission_Temperature',
  'P2P_Button',
  'YawRate',
  'PitchAngle',
  'RideHeight',
  'AnalogShifter',
  'DigitalShifterA',
  'DigitalShifterB',
  'DigitalShifterC',
  'DigitalShifterD',
  'PWMShifter',
  'Shock_FR',
  'Shock_FL',
  'Shock_BR',
  'Shock_BL',
  'Battery_Temperature',
  'JetSki_NoWake_Active',
  'JetSki_Trim',
  'JetSki_SpdLimit',
  'BrakeBiasInc_Btn',
  'BrakeBiasDec_Btn',
  'ExternalETC',
  'AntiLag_Btn',
  'Staging_Btn',
  'Downshift_Btn',
  'Upshift_Btn',
  'Start_Button_On',
  'Start_Button_Off',
  'Gear_Reset_Btn',
  'MapSelection_1_Btn',
  'MapSelection_2_Btn',
  'MapSelection_3_Btn',
  'MapSelection_4_Btn',
  'MapSelection_5_Btn',
  'Dashboard_Btn',
  'ProNitro_CylTrim_10',
  'Interlock_Button',
  'Multifunction_Button',
  'NoWake_Button',
  'ConsumptionReset_Btn',
  'ProNitro_CylTrim_11',
  'MapChange_Button',
  'PreStaging_Button',
  'BrakeSwitch',
  'MechFuelInjection_Btn',
  'ActiveTraction_NextTable_Btn',
  'ActiveTraction_Table1_Btn',
  'ActiveTraction_Table2_Btn',
  'ActiveTraction_Table3_Btn',
  'ActiveTraction_Table4_Btn',
  'ActiveTraction_Table5_Btn',
  'ActiveTraction_Table6_Btn',
  'ActiveTraction_PrevTable_Btn',
  'ActiveTraction_Analog',
  'ActiveTraction_ActTbl',
  'ClutchActive',
  'PaddleShift_Analog',
  'JetSki_DirMode',
  'Gear_Analog',
  'eGate_BoostP_Btn',
  'Frequency_Control',
  'HighBeam',
  'LowBeam',
  'FlexFuel',
  'LockupOn_Button',
  'LockupOff_Button',
  'TurnSignal_Right',
  'TurnSignal_Left',
  'Gear_Pulse',
  'Borb1A',
  'Borb1B',
  'Borb2A',
  'Borb2B',
  'Pedal1',
  'Pedal2',
  'ExtIgnPoint_1',
  'ExtIgnPoint_2',
  'ExtIgnPoint_3',
  'ExtIgnPoint_4',
  'ExtIgnPoint_5',
  'ExtIgnPoint_6',
  'ExtIgnPoint_7',
  'ExtIgnPoint_8',
  'Clutch_Position',
  'IntakeCamPhysPos_1',
  'IntakeCamPhysPos_2',
  'ExhaustCamPhysPos_1',
  'ExhaustCamPhysPos_2',
  'Clutch_Pressure',
  'NitrousBottle_Pressure_1',
  'NitrousBottle_Pressure_2',
  'Transmission_Pressure',
  'Water_Pressure',
  'Wastegate_Pressure_1',
  'Wastegate_Pressure_2',
  'PanVacuum',
  'TorqueConv_Pressure',
  'ReverseLever',
  'O2_Cil01',
  'O2_Cil02',
  'O2_Cil03',
  'O2_Cil04',
  'O2_Cil05',
  'O2_Cil06',
  'O2_Cil07',
  'O2_Cil08',
  'O2_Cil09',
  'O2_Cil10',
  'O2_Cil11',
  'O2_Cil12',
  'O2_Cil13',
  'O2_Cil14',
  'O2_Cil15',
  'O2_Cil16',
  'O2_Right',
  'O2_Left',
  'O2_Exaust',
  'NarrowBand_O2',
  'Track_Temperature',
  'Intercooler_Temp',
  'Oil_Temperature',
  'Tire_Temperature_FR',
  'Tire_Temperature_FL',
  'Tire_Temperature_RR',
  'Tire_Temperature_RL',
  'FuelFlow_Pump_A',
  'FuelFlow_Pump_B',
  'FuelFlow_Pump_C',
  'FuelFlow_Return_A',
  'FuelFlow_Return_B',
  'FuelFlow_Return_C',
  'FuelFlow_Util_A',
  'FuelFlow_Util_B',
  'FuelFlow_Util_C',
  'FuelFlow_Util_Total',
  'FuelFlow_Perc_A',
  'FuelFlow_Perc_B',
  'FuelFlow_Perc_C',
  'Inj_A_Deadtime',
  'Inj_B_Deadtime',
  'Inj_C_Deadtime',
  'AnalogOut_1',
  'AnalogOut_2',
  'AnalogOut_3',
  'AnalogOut_4',
  'EV_Vehicle_State',
  'EV_Battery_Charge',
  'EV_Battery_Autonomy',
  'EV_Battery_TimeToCharge',
  'EV_Btn_Inv_OnOff',
  'EV_Btn_Inv_DriveReverse',
  'EV_Btn_Inv_ChargeStop',
  'EV_Btn_Inv_ChargeRequest',
  'EV_Inv1_Alerts',
  'EV_Inv1_Faults',
  'EV_Inv1_Meas_Temperature',
  'EV_Inv1_Motor_Meas_RPM',
  'EV_Inv1_Motor_Meas_Temperature',
  'EV_Inv1_Motor_Meas_Voltage',
  'EV_Inv1_Motor_Meas_Current',
  'EV_Inv1_Motor_TargetTorque',
  'EV_BMS_Alerts',
  'EV_BMS_Faults',
  'EV_BMS_Meas_CellOpenVoltage',
  'EV_BMS_Meas_PackOpenVoltage',
  'EV_BMS_Meas_BatteryTemperature',
  'ProNitro_CylTrim_12',
  'EV_BMS_Meas_BatteryCurrent',
  'EV_BMS_Meas_BatteryCCL',
  'EV_BMS_Meas_BatteryDCL',
  'EV_Inv1_Meas_DCBus_Voltage',
  'EV_Inv1_State',
  'EV_OBC_Alerts',
  'EV_OBC_Faults',
  'EV_Power',
  'ExtIgn_Energy',
  'Generic_0',
  'Generic_1',
  'Generic_2',
  'Generic_3',
  'Generic_4',
  'Generic_5',
  'Generic_6',
  'Generic_7',
  'Generic_8',
  'Generic_9',
  'Generic_A',
  'Generic_B',
  'Generic_C',
  'Generic_D',
  'Generic_E',
  'Generic_F',
  'EV_Vehicle_DriveDirection',
  'EGate_Duty_1',
  'EGate_Duty_2',
  'BrakeActive',
  'VacuumBrakePressure',
  'VacuumBrakeActive',
  'StrainGauge_P',
  'StrainGauge_N',
  'ETC_1_PWM',
  'ETC_1_RealPos',
  'ETC_2_PWM',
  'ETC_2_RealPos',
  'VCUData_Vago410',
  'VCUData_Vago411',
  'ProNitro_CylTrim_13',
  'ProNitro_CylTrim_14',
  'ProNitro_CylTrim_15',
  'ProNitro_CylTrim_16',
  'Push2Pass_Remaining',
  'FanPush_Remaining',
  'EGate_MAP_Error',
  'EGate_Volts2',
  'DI1Pressure',
  'DI2Pressure',
  'EV_M1_Temp_Probe',
  'Bracket_BumpUpBtn',
  'Bracket_BumpDnBtn',
  'Bracket_PreStagingBtn',
  'Bracket_SuperBumpBtn',
  'TStop_BumpUpBtn',
  'TStop_BumpDownBtn',
  'TStop_SuperBumpBtn',
  'FuelCalc_ResetBtn',
  'FuelCalc_FuelLevel',
  'FuelCalc_FuelLevel_Instant',
  'FuelCalc_Consu_Total',
  'FuelCalc_Consu_Avg',
  'FuelCalc_Consu_Instant',
  'FuelCalc_Dist_Total',
  'FuelCalc_Autonomy',
  'BrakeDisc_Temperature_FR',
  'BrakeDisc_Temperature_FL',
  'BrakeDisc_Temperature_RR',
  'BrakeDisc_Temperature_RL',
  'BlowOff_Pos',
  'AirComp_Active',
  'Boiler_Temperature',
  'DRS_Btn',
  'Wing_Position',
  'Start_Button_Out',
  'EGate_EngineLoad',
  'EGate_MAP_PID',
  'EGate_InitialPos',
  'EGate_1_InitialPosDiff',
  'EGate_2_InitialPosDiff',
  'EGate_1_Flow',
  'EGate_2_Flow',
  'GearShifter',
  'Custom_1',
  'Custom_2',
  'Custom_3',
  'Custom_4',
  'Custom_5',
  'Custom_6',
  'Custom_7',
  'Custom_8',
  'Custom_9',
  'Custom_10',
  'Custom_11',
  'Custom_12',
  'Custom_13',
  'Custom_14',
  'Custom_15',
  'Custom_16',
  'Custom_17',
  'Custom_18',
  'Custom_19',
  'Custom_20',
  'Custom_21',
  'Custom_22',
  'Custom_23',
  'Custom_24',
  'Custom_25',
  'Custom_26',
  'Custom_27',
  'Custom_28',
  'Custom_29',
  'Custom_30',
  'Custom_31',
  'Custom_32',
  'Custom_33',
  'Custom_34',
  'Custom_35',
  'Custom_36',
  'BlowBy_Pressure',
  'MAP_Fallback',
  'BrakePress_R',
  'BrakeBalance',
  'StrainGage',
  'InputShaft_RPM',
  'Flywheel_RPM',
  'Tire_Pressure_FR',
  'Tire_Pressure_FL',
  'Tire_Pressure_RR',
  'Tire_Pressure_RL',
  'GPS_Date',
  'GPS_Time',
  'GPS_Fix_Quality',
  'GPS_Satellites_Tracked',
  'GPS_Altitude',
  'GPS_Speed',
  'GPS_Course',
  'GPS_True_Track_Degrees',
  'GPS_Speed_KPH',
  'Shifter_Park',
  'Shifter_Reverse',
  'Shifter_Neutral',
  'Shifter_Drive',
  'Shifter_Manual',
  'Shifter_Drive_1',
  'Shifter_Drive_2',
  'Shifter_Drive_3',
  'Shifter_Drive_4',
  'Transbrake_Btn',
  'Transbrake_Pulse',
  'EGate_Volts1',
  'GearVolts',
  'Burnout_Button',
  'IMX8Temperature',
  'ALS_Running',
  'PitLimit_On',
  'WMI_Output_On',
  'WMI_Protection_Ok',
  'AutoGearBox_Manual_Mode',
  'Lockup_Active',
  'ProNitrous_On',
  'ProgNitrous1_On',
  'ProgNitrous2_On',
  'BoostControl1_BoosP',
  'BoostControl1_BoosLim',
  'BoostControl2_BoosP',
  'BoostControl2_BoosLim',
  'GearChangeOut_OutEn',
  'P2P_On',
  'TractionCtrl_On',
  'Eletro1_On',
  'Eletro2_On',
  'FuelPump_On',
  'OutByMAP1_On',
  'OutByMAP2_On',
  'LineLock_On',
  'PitLimit_Cut',
  'EGate_BoostP',
  'TractionCtrl_Act',
  'BlowOff_Act',
  'C1C2_Current',
  'C3C4_Current',
  'C5C6_Current',
  'C7C8_Current',
  'C9C10_Current',
  'C11C12_Current',
  'C13C14_Current',
  'C15C16_Current',
  'C17C18_Current',
  'C19C20_Current',
  'C21C22_Current',
  'TwoStep_Act',
  'ThreeStep_Act',
  'Burnout_Act',
  'Launch_Ok',
  'Injection_BankA_Cyl1',
  'Injection_BankA_Cyl2',
  'Injection_BankA_Cyl3',
  'Injection_BankA_Cyl4',
  'Injection_BankA_Cyl5',
  'Injection_BankA_Cyl6',
  'Injection_BankA_Cyl7',
  'Injection_BankA_Cyl8',
  'Injection_BankA_Cyl9',
  'Injection_BankA_Cyl10',
  'Injection_BankA_Cyl11',
  'Injection_BankA_Cyl12',
  'Injection_BankA_Cyl13',
  'Injection_BankA_Cyl14',
  'Injection_BankA_Cyl15',
  'Injection_BankA_Cyl16',
  'Ignition_Cyl1',
  'Ignition_Cyl2',
  'Ignition_Cyl3',
  'Ignition_Cyl4',
  'Ignition_Cyl5',
  'Ignition_Cyl6',
  'Ignition_Cyl7',
  'Ignition_Cyl8',
  'Ignition_Cyl9',
  'Ignition_Cyl10',
  'Ignition_Cyl11',
  'Ignition_Cyl12',
  'Ignition_Cyl13',
  'Ignition_Cyl14',
  'Ignition_Cyl15',
  'Ignition_Cyl16',
  'Ignition_Cut_Level',
  '1msTickRel',
  'GearChangeOut_Reset',
  'GearChangeOut_GR',
  'GearChangeOut_G1',
  'GearChangeOut_G2',
  'GearChangeOut_G3',
  'GearChangeOut_G4',
  'GearChangeOut_G5',
  'GearChangeOut_G6',
  'GearChangeOut_G7',
  'GearChangeOut_G8',
  'GearChangeOut_G9',
  'GearChangeOut_G10',
  'GearChangeOut_G11',
  'GearChangeOut_G12',
  'GearChangeOut_G13',
  'GearChangeOut_G14',
  'GearChangeOut_G15',
  'GearChangeOut_G16',
  'MFI_Stage_1',
  'MFI_Stage_2',
  'MFI_Stage_3',
  'MFI_Stage_4',
  'MFI_Stage_5',
  'MFI_Stage_6',
  'MFI_Stage_7',
  'MFI_Stage_8',
  'GenOut_Val_1',
  'GenOut_Val_2',
  'GenOut_Val_3',
  'GenOut_Val_4',
  'GenOut_Val_5',
  'GenOut_Val_6',
  'GenOut_Val_7',
  'GenOut_Val_8',
  'GenOut_Val_9',
  'GenOut_Val_10',
  'GenOut_Val_11',
  'GenOut_Val_12',
  'GenOut_Val_13',
  'GenOut_Val_14',
  'GenOut_Val_15',
  'GenOut_Val_16',
  'GenOut_Val_17',
  'GenOut_Val_18',
  'GenOut_Val_19',
  'GenOut_Val_20',
  'Sensor_5V',
  'V_IGN',
  'ProNitrousStage_1',
  'ProNitrousStage_2',
  'ProNitrousStage_3',
  'ProNitrousStage_4',
  'ProNitrousStage_5',
  'ProNitrousStage_6',
  'ProNitrousStage_7',
  'ProNitrousStage_8',
  'ProNitrousStage_9',
  'ProNitrousStage_10',
  'ProNitrousStage_11',
  'ProNitrousStage_12',
  'Push_Ready',
  'WaterPump_Act',
  'SafeMode_1',
  'SafeMode_2',
  'SafeMode_3',
  'SafeMode_4',
  'PedalCusTblSel',
  'PedalActivePosTbl',
  'BrakeBias_Tgt',
  'BrakeBias_Act',
  'EGate_1_AutoCalibPos',
  'EGate_2_AutoCalibPos',
  'Lap_RaceTime',
  'RemRaceTime',
  'WipperSwitch',
  'RainSwitch',
  'AmbientTemperature',
  'AirBoxTemperature',
  'ActualFlag',
  'DRS_Ready',
  'DRS_Active',
  'P2P_Cooldown',
  'Lap_LastTime',
  'Lap_Number',
  'RainModeOn',
  'P2P_PrePushCountdown',
  'P2P_PrePushOn',
  'AirConditioner_CompOn',
  'P2P_PushCountdown',
  'MotronixWhlEnc_0',
  'MotronixWhlEnc_1',
  'MotronixWhlEnc_2',
  'DRS_Remaining',
  'BrakeBias_Preset',
  'Alarm_OverRPM',
  'Alarm_InjectorOpen',
  'Alarm_MinOilPressureRPM',
  'Alarm_ExcessMAPPressure',
  'Alarm_HighOilPressure',
  'Alarm_LowOilPressure',
  'Alarm_LowFuelPressure',
  'Alarm_HighEngineTemp',
  'Alarm_DifferentialFuelPressure',
  'Alarm_InjectorsFail',
  'Alarm_EGT_Hi',
  'Alarm_EGT_Lo',
  'Alarm_CLLimits',
  'Alarm_FlexFuelMaxPress',
  'Alarm_FlexFuelSensor',
  'Alarm_RPMReadError',
  'Alarm_TurboOverspeed',
  'Alarm_PanVacuummPressLost',
  'Alarm_EGT_CylOverheat',
  'Alarm_EGate_Overheat',
  'Alarm_InjectorDriver',
  'Alarm_WMI_LevelAlertEn',
  'Alarm_EGateOverload',
  'Alarm_BlowByHighPressure',
  'Alarm_TransmissionTempHigh',
  'Alarm_BatteryVoltageHigh',
  'Alarm_BatteryVoltageLow',
  'Alarm_MAPDiffHigh',
  'Alarm_EGateErrorHigh',
  'Alarm_CLLimitsAdv',
  'Alarm_AirCompressor',
  'EGateEmergencyMode',
  'Pedal_Delta',
  'EGateMAPOpenLoop',
  'EGatePosCorrelationErr',
  'EGatePosLockedErr',
  'EGatePosClosedState',
  'EGatePosSafeMode',
  'EGatePosCritical',
  'EGatePosPreLoad',
  'EGatePosDeadBand',
  'MotecAlerts',
  'HBridge_1_Protection',
  'HBridge_2_Protection',
  'HBridge_3_Protection',
  'HBridge_4_Protection',
  'HBridge_5_Protection',
  'HBridge_6_Protection',
  'HBridge_7_Protection',
  'HBridge_8_Protection',
  'HBridge_9_Protection',
  'HBridge_10_Protection',
  'HBridge_11_Protection',
  'HBridge_12_Protection',
  'HBridge_13_Protection',
  'HBridge_14_Protection',
  'HBridge_15_Protection',
  'HBridge_16_Protection',
  'HBridge_17_Protection',
  'HBridge_18_Protection',
  'HBridge_19_Protection',
  'HBridge_20_Protection',
  'HBridge_21_Protection',
  'HBridge_22_Protection',
  'HBridge_1_2_Overcurrent',
  'HBridge_3_4_Overcurrent',
  'HBridge_5_6_Overcurrent',
  'HBridge_7_8_Overcurrent',
  'HBridge_9_10_Overcurrent',
  'HBridge_11_12_Overcurrent',
  'HBridge_13_14_Overcurrent',
  'HBridge_15_16_Overcurrent',
  'HBridge_17_18_Overcurrent',
  'HBridge_19_20_Overcurrent',
  'HBridge_21_22_Overcurrent',
  'ETC_Stuck_Error',
  'ETC_Correlation_Error',
  'ETC_Tracking_Error',
  'Pedal_Correlation_Error',
  'Pedal_Stuck_Error',
  'VBatPowerSource',
  'Alarm_GearChangeError',
  'Alarm_SteeringPress',
  'SteeringPress',
  'MAP_Internal',
  'ATM_SolenoidA',
  'ATM_SolenoidB',
  'ATM_SolenoidC',
  'ATM_SolenoidD',
  'ATM_SolenoidE',
  'ATM_SolenoidF',
  'ATM_SolenoidG',
  'ATM_SolenoidH',
  'ATM_SolenoidLine',
  'ATM_SolenoidAcc',
  'ATM_GearEngaged',
  'Intercooler_Press',
  'Injection_Cut_Level',
  'ETCBoostCtrl_BoostP_Btn',
  'ETCBoostCtrl_Target',
  'ETCBoostCtrl_P',
  'ETCBoostCtrl_I',
  'ETCBoostCtrl_D',
  'ETCBoostCtrl_PosInit',
  'ETCBoostCtrl_Result',
  'ETCBoostCtrl_Error',
  'Alarm_BrakeBias_Current',
  'CAN_BusLoadA',
  'CAN_BusLoadB',
  'CAN_BusLoadC',
  'CAN_BusOff',
  'CAN_FCFrmErr',
  'CANCustom_FrmErr',
  'GCM_Out_Up',
  'GCM_Out_Dn',
  'MAP_OnFallback',
  'GCM_UpShift_Denied',
  'GCM_DownShift_Denied',
  'GCM_Deny_Code',
  'Idle_OffSet_Level',
  'Idle_OffSet_Btn',
  'Lap_CurrentTime',
  'Lap_GainLoss',
  'Lap_Fastest',
  'Lap_Predicted',
  'O2_Temp_General',
  'O2_Temp_Left',
  'O2_Temp_Right',
  'O2_Temp_Cyl1',
  'O2_Temp_Cyl2',
  'O2_Temp_Cyl3',
  'O2_Temp_Cyl4',
  'O2_Temp_Cyl5',
  'O2_Temp_Cyl6',
  'O2_Temp_Cyl7',
  'O2_Temp_Cyl8',
  'O2_Temp_Cyl9',
  'O2_Temp_Cyl10',
  'O2_Temp_Cyl11',
  'O2_Temp_Cyl12',
  'O2_Temp_Cyl13',
  'O2_Temp_Cyl14',
  'O2_Temp_Cyl15',
  'O2_Temp_Cyl16',
  'FTCAN_PID_CAN_A',
  'FTCAN_PID_CAN_B',
  'FTCAN_PID_CAN_C',
  'FlexFuel_Inj_PrimeStart_Comp',
  'FlexFuel_Inj_Fast_Comp',
  'FlexFuel_BoostCtrl_Comp',
  'FlexFuel_GenPWM_Comp',
  'ShifterPosition_CAN',
  'FTSparkDurationDeg',
  'FTSparkDurationUs',
  'FlexFuel_Mixture',
  'Alarm_ETC_Error',
  'GearDetectionCAN',
  'Wheel_Signal',
  'Sync_Signal',
  'RPM_Wheel',
  'Boost_IncDuty_1',
  'Boost_DecDuty_1',
  'Boost_Period_1',
  'Boost_IncDuty_2',
  'Boost_DecDuty_2',
  'Boost_Period_2',
  'ProgNitro1_RPM_Ign_Comp',
  'ProgNitro1_RPM_Enrich',
  'ProgNitro1_PWM_Ign_Comp',
  'ProgNitro1_PWM_Enrich_A',
  'ProgNitro1_PWM_Enrich_B',
  'ProgNitro1_PWM_Enrich_C',
  'ProgNitro2_RPM_Ign_Comp',
  'ProgNitro2_RPM_Enrich',
  'ProgNitro2_PWM_Ign_Comp',
  'ProgNitro2_PWM_Enrich_A',
  'ProgNitro2_PWM_Enrich_B',
  'ProgNitro2_PWM_Enrich_C',
  'Injection_BankB_Cyl1',
  'Injection_BankB_Cyl2',
  'Injection_BankB_Cyl3',
  'Injection_BankB_Cyl4',
  'Injection_BankB_Cyl5',
  'Injection_BankB_Cyl6',
  'Injection_BankB_Cyl7',
  'Injection_BankB_Cyl8',
  'Injection_BankB_Cyl9',
  'Injection_BankB_Cyl10',
  'Injection_BankB_Cyl11',
  'Injection_BankB_Cyl12',
  'Injection_BankB_Cyl13',
  'Injection_BankB_Cyl14',
  'Injection_BankB_Cyl15',
  'Injection_BankB_Cyl16',
  'Injection_BankC_Cyl1',
  'Injection_BankC_Cyl2',
  'Injection_BankC_Cyl3',
  'Injection_BankC_Cyl4',
  'Injection_BankC_Cyl5',
  'Injection_BankC_Cyl6',
  'Injection_BankC_Cyl7',
  'Injection_BankC_Cyl8',
  'Injection_BankC_Cyl9',
  'Injection_BankC_Cyl10',
  'Injection_BankC_Cyl11',
  'Injection_BankC_Cyl12',
  'Injection_BankC_Cyl13',
  'Injection_BankC_Cyl14',
  'Injection_BankC_Cyl15',
  'Injection_BankC_Cyl16',
  'BlipCompensation_Level',
  'BlipCompensation_Btn',
  'Injection_Phase_B',
  'Injection_Phase_C',
  'PnH_VBat_M1',
  'PnH_VBat_M2',
  'PnH_PCT_M1_1',
  'PnH_PCT_M1_2',
  'PnH_PCT_M2_1',
  'PnH_PCT_M2_2',
  'ExtIgn_OutDischTime_1',
  'ExtIgn_OutDischTime_2',
  'ExtIgn_OutDischTime_3',
  'ExtIgn_OutDischTime_4',
  'ExtIgn_OutDischTime_5',
  'ExtIgn_OutDischTime_6',
  'ExtIgn_OutDischTime_7',
  'ExtIgn_OutDischTime_8',
  'ExtIgn_PowerSupply',
  'ExtIgn_PowerSupplyDrop',
  'ExtIgn_PowerLevel',
  'ExtIgn_Temperature',
  'ExtIgn_CapCharge_1',
  'ExtIgn_CapCharge_2',
  'ExtIgn_CapTime_1',
  'ExtIgn_CapTime_2',
  'ExtIgn_SwitchVolt',
  'ExtIgn_CPU_Supply',
  'ExtIgn_CPU_Temp',
  'ExtIgn_OperTime',
  'ExtIgnB_OutDischTime_1',
  'ExtIgnB_OutDischTime_2',
  'ExtIgnB_OutDischTime_3',
  'ExtIgnB_OutDischTime_4',
  'ExtIgnB_OutDischTime_5',
  'ExtIgnB_OutDischTime_6',
  'ExtIgnB_OutDischTime_7',
  'ExtIgnB_OutDischTime_8',
  'ExtIgnB_PowerSupply',
  'ExtIgnB_PowerSupplyDrop',
  'ExtIgnB_PowerLevel',
  'ExtIgnB_Temperature',
  'ExtIgnB_CapCharge_1',
  'ExtIgnB_CapCharge_2',
  'ExtIgnB_CapTime_1',
  'ExtIgnB_CapTime_2',
  'ExtIgnB_SwitchVolt',
  'ExtIgnB_CPU_Supply',
  'ExtIgnB_CPU_Temp',
  'ExtIgnB_OperTime',
  'ProgEngineTurnOff_Sig',
  'ProgEngineTurnOff_TO',
  'TBO_OutState',
  'VVTI_Intake1_Deviation',
  'VVTI_Exaust1_Deviation',
  'VVTI_Intake2_Deviation',
  'VVTI_Exaust2_Deviation',
  'VVTI_Intake1_PWM',
  'VVTI_Exaust1_PWM',
  'VVTI_Intake2_PWM',
  'VVTI_Exaust2_PWM',
  'VVTI_Intake_Target',
  'VVTI_Exaust_Target',
  'ShiftLight_Output',
  'VTEC_Output',
  'Blip_Output',
  'Bracket_SelfTime',
  'Bracket_OppTime',
  'Bracket_Delay1',
  'MAP_Diff',
  'PDM_TotalCurrent',
  'PDM_BatteryVoltage',
  'PDM_OutputCurrent1',
  'PDM_OutputCurrent2',
  'PDM_OutputCurrent3',
  'PDM_OutputCurrent4',
  'PDM_OutputCurrent5',
  'PDM_OutputCurrent6',
  'PDM_OutputCurrent7',
  'PDM_OutputCurrent8',
  'PDM_OutputCurrent9',
  'PDM_OutputCurrent10',
  'PDM_OutputCurrent11',
  'PDM_OutputCurrent12',
  'PDM_OutputCurrent13',
  'PDM_OutputCurrent14',
  'PDM_OutputCurrent15',
  'PDM_OutputCurrent16',
  'GearRatio_Calculated',
  'ATM_KissPointDetected',
  'ATM_HoldAdaptiveActive',
  'Gear_Commanded',
  'ATM_GearChangeInProgress',
  'ATM_OutgoingReleasedEarly',
  'ATM_OutgoingLocked',
  'NightMode',
  'TimBsdRPMLimitCut',
  'TimBsdRPMLimitRetard',
  'TimBsdTimeEnrichment',
  'TimBsdTimeRetard',
  'TimBsdDSSpdCut',
  'TimBsdDSSpdRetard',
  'TimBsdETCPosLimiter',
  '1msTick',
  'Launch_Delay1_Act',
  'Launch_Delay2_Act',
  'PreStaging_Output_Act',
  'TimBsdRearAxle_Cut',
  'TimBsdRearAxle_Retard',
  'RearAxle_Height',
  'SleepWake_Btn',
  'IntermShaft_RPM_1',
  'IntermShaft_RPM_2',
  'UpShift_Signal',
  'DownShift_Signal',
  'FlexFuel_Inj_Comp',
  'FlexFuel_Ign_Comp',
  'FlexFuel_O2_Comp',
  'FlexFuel_Compensation',
  'PDM_OutputCurrent17',
  'PDM_OutputCurrent18',
  'PDM_OutputCurrent19',
  'PDM_OutputCurrent20',
  'PDM_OutputCurrent21',
  'PDM_OutputCurrent22',
  'PDM_OutputCurrent23',
  'PDM_OutputCurrent24',
  'FuelCalc_FuelLevel_Filtered',
  'Alarm_WaterPressRange',
  'Alarm_OilTempRange',
  'Alarm_Generic',
  'Shock_Rate_FR',
  'Shock_Rate_FL',
  'Shock_Rate_BR',
  'Shock_Rate_BL',
  'Eletro1_Duty',
  'Eletro2_Duty',
  'AnalogInput_Voltage_0',
  'AnalogInput_Voltage_1',
  'AnalogInput_Voltage_2',
  'AnalogInput_Voltage_3',
  'AnalogInput_Voltage_4',
  'AnalogInput_Voltage_5',
  'AnalogInput_Voltage_6',
  'AnalogInput_Voltage_7',
  'AnalogInput_Voltage_8',
  'AnalogInput_Voltage_9',
  'AnalogInput_Voltage_10',
  'AnalogInput_Voltage_11',
  'AnalogInput_Voltage_12',
  'AnalogInput_Voltage_13',
  'AnalogInput_Voltage_14',
  'AnalogInput_Voltage_15',
  'AnalogInput_Voltage_16',
  'AnalogInput_Voltage_17',
  'AnalogInput_Voltage_18',
  'AnalogInput_Voltage_19',
  'AnalogInput_Voltage_20',
  'AnalogInput_Voltage_21',
  'AnalogInput_Voltage_22',
  'AnalogInput_Voltage_23',
  'AnalogInput_Voltage_24',
  'AnalogInput_Voltage_25',
  'AnalogInput_Voltage_26',
  'AnalogInput_Voltage_27',
  'AnalogInput_Voltage_28',
  'AnalogInput_Voltage_29',
  'AnalogInput_Voltage_30',
  'AnalogInput_Voltage_31',
  'AnalogInput_Voltage_32',
  'AnalogInput_Voltage_33',
  'AnalogInput_Voltage_34',
  'AnalogInput_Voltage_35',
  'MainRelayOut',
  'MathChannel',
];
